/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var ScrollReveal = { };
var masonry = { };

( function( $ ) {

	ScrollReveal.init = function() {
		$( '.masonry .col' ).each( function( i ) {
			var bottomObject = $( this ).offset().top + 20;
			var bottomWindow = $( window ).scrollTop() + $( window ).height();

			if( bottomWindow > bottomObject ) {
				$( this ).animate( {
					'opacity': '1',
					'marginTop': '0'
				}, 500 );
			}
		} );
	};

	ScrollReveal.animation = function() {
		$( window ).scroll( function() {
			ScrollReveal.init();
		} );
	};

	masonry = {
		init: function() {
			this.globalmasonry( '.masonry', 991 );
			this.globalmasonry( '.masonry-about', 480 );
			
			$( '.context-block .outline-btn' ).on( 'click', function( event ) {
				event.preventDefault();
				$( this ).prev().toggleClass( 'in' );

				var open = $( this ).data( 'text-open' );
				var close = $( this ).data( 'text-close' );

				if( $( this ).prev().hasClass( 'in' ) ) {
					$( this ).html( open );
				} else {
					$( this ).html( close );
				}

				$( '.masonry' ).masonry();
			} );
		},
		globalmasonry: function( param, breakpoint ) {
			var container = $( param );

			if( $( window ).width() > breakpoint ) {
				var $grid = container.masonry( {
					initLayout: false,
					columnWidth: '.col',
					itemSelector: '.col'
				} );

				container.imagesLoaded( function() {
					$grid.masonry();
				} );

				$grid.one( 'layoutComplete', function() {
					$( '.masonry .col' ).each( function() {
						$( this ).css( {
							'margin-top': 60,
							'opacity': 0
						} );
					} ).promise().done( function() {
						ScrollReveal.init();
						ScrollReveal.animation();
					} );
				} );
			}
		}
	};

	$( window ).load( function() {
		$( '.masonry .col' ).css( 'display', 'none' );

		$( '.loader' ).fadeOut( 'slow' ).promise().done( function() {
			masonry.init();
			
			$( '.masonry' ).show();
			$( '.masonry .col' ).css( 'display', 'block' );
		} );
	} );
	
	$( '.masonry' ).on( 'layoutComplete', function( msnryInstance, laidOutItems ) {
		$( '.context-block' ).each( function() {
			var contentHeight = 0;
			
			$( this ).find( '.context-body p' ).each( function() {
				contentHeight += $( this ).height();
			} );

			if( contentHeight <= 336 ) {
				$( this ).find( '.outline-btn' ).hide();
				$( this ).find( '.context-body' ).removeClass( 'white-overlay' );
			}
		} );
	} );

} )( jQuery );
